export default () => ({
  tab: 0,
});